import { DataBean } from "../DataBean";

export class PayrollFactor extends DataBean {


    public async getPayrollFactorCatalogByPayrollType(idPayrollType:any,valueClassID:any,fortnightType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollFactorCatalogByPayrollType_Number_Number_Number", [idPayrollType,valueClassID,fortnightType]);
    }


    public async getPayrollFactorCatalog(valueClassID:any,fortnightType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollFactorCatalog_Number_Number", [valueClassID,fortnightType]);
    }
    

 
}